import { ReverseProductUploadContext } from 'app/reverse-auction-upload-wizard/reverse-auction-upload-wizard.component';
import { UtilService } from 'app/_services/util.service';
import { bind } from 'app/_decorators/bind.decorator';
import * as angular from 'angular';
import { mgoAngularWizard } from '../custom';

class ReverseUploadWizardProductComponentCtrl implements ng.IController {
    private wizardCtrl: mgoAngularWizard.Wizard<ReverseProductUploadContext>;
    public networkpointHasChanged: boolean = false;
    public loggedInUser: LoginResult;
    public productCharacters: any = [
        'INCREASE_OF_DEMAND',
        'DECREASE_OF_DEMAND'
    ];
    public productTypes: any = ['BUY_BACK', 'FLOW_COMMITMENT'];
    public minRuntimeStart: Date;

    constructor(
        private authService,
        private utilService: UtilService
    ) {
        this.minRuntimeStart = new Date();
    }

    $onInit(): void {
        this.authService.userLoginPromise.promise.then(
            (loggedInUser: LoginResult) => {
                this.loggedInUser = loggedInUser;
                this.initNetworkPoint();

                if (!this.wizardCtrl.context.data.offerId) {
                    this.wizardCtrl.context.data.offerId =
                        this.utilService.generateGuid(2);
                }
                this.wizardCtrl.context.data.runtime =
                    this.utilService.getRunTimeSuggestion('MONTH');
            }
        );
    }

    private getNetworkPointIdentifierForLoggedInTso() {
        //tso is responsible for both entry & exit - so let's find out which direction he has chosen
        if (
            this.wizardCtrl.context.data.selectedNetworkPoint.tso0Name ==
                this.loggedInUser.tsoName &&
            this.wizardCtrl.context.data.selectedNetworkPoint.tso1Name ==
                this.loggedInUser.tsoName
        ) {
            return this.wizardCtrl.context.data.networkPoint.direction ===
                'EXIT'
                ? this.wizardCtrl.context.data.selectedNetworkPoint.identifier0
                : this.wizardCtrl.context.data.selectedNetworkPoint.identifier1;
        }
        //tso is responsible for exit or entry - so let's get his access point identifier
        else {
            if (
                this.wizardCtrl.context.data.selectedNetworkPoint.tso0Name ==
                this.loggedInUser.tsoName
            ) {
                return this.wizardCtrl.context.data.selectedNetworkPoint
                    .identifier0;
            } else {
                return this.wizardCtrl.context.data.selectedNetworkPoint
                    .identifier1;
            }
        }
    }

    @bind
    public initNetworkPoint() {
        var dir;
        if (this.wizardCtrl.context.data.selectedNetworkPoint.bundled) {
            if (angular.isUndefined(this.wizardCtrl.context.data.bundled)) {
                this.wizardCtrl.context.data.bundled = true;
            }

            //tso is responsible for both entry & exit - so let leave this decision to him
            if (
                this.wizardCtrl.context.data.selectedNetworkPoint.tso0Name ==
                    this.loggedInUser.tsoName &&
                this.wizardCtrl.context.data.selectedNetworkPoint.tso1Name ==
                    this.loggedInUser.tsoName
            ) {
                this.setNetworkpointDirection(0);
            }
            //tso is responsible for exit or entry - let's find out
            else {
                if (
                    this.wizardCtrl.context.data.selectedNetworkPoint
                        .tso0Name == this.loggedInUser.tsoName
                ) {
                    dir = 0;
                } else if (
                    this.wizardCtrl.context.data.selectedNetworkPoint
                        .tso1Name == this.loggedInUser.tsoName
                ) {
                    dir = 1;
                }
                this.setNetworkpointDirection(dir);
            }
        } else {
            this.wizardCtrl.context.data.bundled = false;
            this.setNetworkpointDirection(0);
        }
    }

    public setNetworkpointDirection(direction) {
        var directionstring: string;
        if (
            this.wizardCtrl.context.data.selectedNetworkPoint.direction ==
            'BUNDLE'
        ) {
            if (direction == 0) {
                directionstring = 'EXIT';
            }
            if (direction == 1) {
                directionstring = 'ENTRY';
            }
        } else {
            directionstring =
                this.wizardCtrl.context.data.selectedNetworkPoint.direction;
        }
        if (!angular.isUndefined(this.wizardCtrl.context.data.networkPoint)) {
            if (
                this.wizardCtrl.context.data.networkPoint.id !=
                this.wizardCtrl.context.data.selectedNetworkPoint[
                    'id' + direction
                ]
            ) {
                this.networkpointHasChanged = true;
            }
        }

        this.wizardCtrl.context.data.networkPoint = {
            id: this.wizardCtrl.context.data.selectedNetworkPoint[
                'id' + direction
            ],
            identifier:
                this.wizardCtrl.context.data.selectedNetworkPoint[
                    'identifier' + direction
                ],
            name: this.wizardCtrl.context.data.selectedNetworkPoint[
                'name' + direction
            ],
            direction: directionstring,
            capacityCategories:
                this.wizardCtrl.context.data.selectedNetworkPoint[
                    'capacityCategories' + direction
                ]
        };
    }

    public submit(isValid): boolean {
        if (!isValid) {
            return false;
        }

        this.wizardCtrl.next();
        return true;
    }

    public checkRuntimeStartEndEquality(runtimeStart, runtimeEnd): boolean {
        var runtimeStart1 = new Date(runtimeStart);
        var runtimeEnd1 = new Date(runtimeEnd);
        if (
            runtimeEnd1.getMonth() === runtimeStart1.getMonth() &&
            runtimeEnd1.getFullYear() === runtimeStart1.getFullYear() &&
            runtimeEnd1.getDay() === runtimeStart1.getDay() &&
            runtimeEnd1.getTime() === runtimeStart1.getTime()
        ) {
            return true;
        } else {
            return false;
        }
    }
}

angular.module('app').component('pkpReverseAuctionUploadWizardProduct', {
    controller: ReverseUploadWizardProductComponentCtrl,
    template:
        require('app/reverse-auction-upload-wizard/reverse-auction-upload-wizard-product.component.html'),
    require: {
        wizardCtrl: '^^wizard'
    },
    bindings: {}
});
